import WistiaEmbed from 'components/WistiaEmbed';
import * as React from 'react';
export default {
  WistiaEmbed,
  React
};